

import { useState } from 'react';
import { createContext } from 'react';

//const [globalState, setGlobalState] = ({value: "test value"});
const globalState = "temp";
const setGlobalState = {};
export const AppContext = createContext({globalState, setGlobalState});

export const AppContextProvider = ({ children }) => {
    
    //AppContext.value = {"ijk": "lmn"};
    return (
      <AppContext.Provider value={{ globalState, setGlobalState }}>
      </AppContext.Provider>
    );
  };
